// extracted by mini-css-extract-plugin
export default {"allColumn":"newsList_allColumn__S1RDA","card":"newsList_card__HoFFG","newsImages":"newsList_newsImages__dU64z","description":"newsList_description__rC3fp"};